export default __webpack_public_path__ + "static/media/Slide22.adf1ec33.PNG";